import axios, { type AxiosError } from 'axios';
import config from 'config/config';
import posthog from 'posthog-js';
import type { Product } from 'types';

declare const VERSION: string;

const getProductByHandle = async ({
  productName,
  storeId,
  currencyConversionRate,
  customerCurrency
}: {
  productName: string;
  storeId: string;
  customerCurrency?: string | null;
  currencyConversionRate?: number;
}): Promise<Product | undefined> => {
  try {
    const response = await axios<{ data: Product }>({
      method: 'get',
      params: {
        currency: customerCurrency || undefined,
        currencyConversionRate,
        handle: productName
      },
      url: `${config.productApi.url}/api/stores/${storeId}/products/product-by-handle/`
    });
    return response?.data?.data;
  } catch (e) {
    const error = e as AxiosError;
    posthog?.capture('getProductByHandleError', { error: error.toJSON(), version: VERSION });
    console.error(e);
  }
};

export default getProductByHandle;
